import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";

export const getPagosProveedoresEncFechasWere = async (fechas) => {
    const result = await PrivateInterceptorsPR(`CXP/PagoProveedores/FechasWere`, 'POST', { FechaInicio: fechas[0], FechaFinal: fechas[1] });
    return result;
}

export const getPagoProveedorEnc = async (IdPago) => {
    const result = await PrivateInterceptorsPR(`CXP/PagoProveedores/Encabezado/${IdPago}`, 'GET');
    return result;
}

export const getPagoProveedorDetalles = async (IdPago) => {
    const result = await PrivateInterceptorsPR(`CXP/PagoProveedores/Detalles/${IdPago}`, 'GET');
    return result;
}

export const postPagoProveedor = async (informacion) => {
    const result = await PrivateInterceptorsPR(`CXP/PagoProveedores/IUPagoProveedor`, 'POST', informacion);
    return result;
}